/**
 * Gemensam tooltip och ikonknapp.
 *
 * Hjalptext: visas efter 300 ms, både vid hovring och när elementet får
 * fokus från tangentbordet (MUI öppnar på focus-visible, inte på musklick).
 *
 * IkonKnapp: 40 × 40 px, aria-label och tooltip i ett, med valfri röd siffra.
 */
import React from 'react';
import { Tooltip, IconButton, Badge } from '@mui/material';

export const HJALPTEXT_FORDROJNING_MS = 300;

export default function Hjalptext({ title, children, ...rest }) {
  return (
    <Tooltip title={title} enterDelay={HJALPTEXT_FORDROJNING_MS}
      enterNextDelay={HJALPTEXT_FORDROJNING_MS} {...rest}>
      {children}
    </Tooltip>
  );
}

/**
 * etikett blir aria-label och, om tips saknas, tooltipens text.
 * siffra > 0 ritas som röd badge på ikonen.
 */
export const IkonKnapp = React.forwardRef(function IkonKnapp(
  { etikett, tips, siffra, children, sx, ...rest }, ref,
) {
  return (
    <Hjalptext title={tips || etikett}>
      <IconButton ref={ref} aria-label={etikett} {...rest}
        sx={{ width: 40, height: 40, flexShrink: 0, ...sx }}>
        {siffra > 0 ? (
          <Badge badgeContent={siffra} color="error" max={99}
            sx={{ '& .MuiBadge-badge': { fontWeight: 800, fontSize: '0.65rem' } }}>
            {children}
          </Badge>
        ) : children}
      </IconButton>
    </Hjalptext>
  );
});
